import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeCircle,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import BillingAddressForm from "../../../components/BillingAddressForm";

const PLNPlusMemberInformationPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const pageRef = useRef();

  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [newUserName, setNewUserName] = useState<any>(null);
  const [newUserEmail, setNewUserEmail] = useState<any>(null);
  const [newUserInstagram, setNewUserInstagram] = useState<any>(null);
  const [newUserPhone, setNewUserPhone] = useState<any>(null);
  const [newUserPhoneReadable, setNewUserPhoneReadable] = useState<any>(null);
  const [newUserShippingAddress, setNewUserShippingAddress] =
    useState<any>(null);
  const [newUserBillingAddress, setNewUserBillingAddress] = useState<any>(null);
  const [present] = useIonToast();

  const submit = async () => {
    setSubmitting(true);

    API.updateProfile(newUserName, newUserEmail, newUserPhone, newUserInstagram).then(
      async (res: any) => {
        const user = res?.data?.data?.user;

        console.log("USER", user);

        setUser(user);

        await StorageUtils.set("user_customer", user);

        API.updateBillingAddress(
          newUserName,
          newUserBillingAddress?.address1,
          newUserBillingAddress?.address2,
          newUserBillingAddress?.city,
          newUserBillingAddress?.state,
          newUserBillingAddress?.zip,
          newUserPhone,
        ).then(
          async (res: any) => {
            const customer = res?.data?.data?.customer;

            console.log("CUSTOMER", customer);

            user.customer = customer;

            setUser(user);

            await StorageUtils.set("user_customer", user);

            if (user?.customer?.subscription?.plan?.procurement != "pickup") {
              API.updateShippingAddress(
                newUserName,
                newUserShippingAddress?.address1,
                newUserShippingAddress?.address2,
                newUserShippingAddress?.city,
                newUserShippingAddress?.state,
                newUserShippingAddress?.zip,
                newUserPhone,
              ).then(async (res: any) => {
                const customer = res?.data?.data?.customer;

                console.log("CUSTOMER", customer);

                user.customer = customer;

                setUser(user);

                await StorageUtils.set("user_customer", user);

                setSubmitting(false);

                next();
              });
            } else {
              setSubmitting(false);

              next();
            }
          },
          (err: any) => {
            setSubmitting(false);
            present({
              message: `We're having trouble updating your billing address. ${
                err?.response?.data?.message ?? "Please try again."
              }}`,
              duration: 1500,
              position: "bottom",
              icon: closeCircle,
              color: "danger",
              layout: "baseline",
              mode: "ios",
              buttons: [
                {
                  text: "OK",
                  role: "cancel",
                },
              ],
            });
          },
        );
      },
      (e: any) => {
        setSubmitting(false);

        present({
          message: `We're having trouble updating your billing address. ${
            e?.response?.data?.message ?? "Please try again."
          }}`,
          duration: 1500,
          position: "bottom",
          icon: closeCircle,
          color: "danger",
          layout: "baseline",
          mode: "ios",
          buttons: [
            {
              text: "OK",
              role: "cancel",
            },
          ],
        });
      },
    );
  };

  const stepIsValid = () => {
    if (!newUserName || !newUserEmail || !newUserPhone) {
      return false;
    }

    if (
      !StringUtils.isValidPhone(newUserPhone) ||
      !StringUtils.isValidEmail(newUserEmail)
    ) {
      return false;
    }

    if (!newUserBillingAddress) {
      return false;
    }

    if (
      user?.customer?.subscription?.plan?.procurement != "pickup" &&
      !newUserShippingAddress
    ) {
      return false;
    }

    if (
      !newUserBillingAddress?.address1 ||
      !newUserBillingAddress?.city ||
      !newUserBillingAddress?.state ||
      !newUserBillingAddress?.zip
    ) {
      return false;
    }

    if (
      user?.customer?.subscription?.plan?.procurement != "pickup" &&
      (!newUserShippingAddress?.address1 ||
        !newUserShippingAddress?.city ||
        !newUserShippingAddress?.state ||
        !newUserShippingAddress?.zip)
    ) {
      return false;
    }

    return true;
  };

  let loadUser = async () => {
    setLoading(true);

    const user = await StorageUtils.get("user_customer");

    setUser(user);

    const token = await StorageUtils.get("user_authorizationToken");

    API.setAuthToken(token);

    API.getAccount()
      .then(
        async (data: any) => {
          setUser(data?.data?.data?.user);

          // console.log(data?.data?.data?.user);

          // Set the name email and phone from user information
          let phone = StringUtils.formatPhoneNumberWhileTyping(
            data?.data?.data?.user?.phone,
          );

          setNewUserEmail(data?.data?.data?.user?.email?.toLowerCase());
          setNewUserPhone(phone?.value?.split(" ").join(""));
          setNewUserPhoneReadable(phone?.formatted);
          setNewUserName(data?.data?.data?.user?.name);
          
          setNewUserInstagram(
            data?.data?.data?.user?.instagramHandle?.replace(/^@+/, "") ?? null,
          );

          if (data?.data?.data?.user?.customer?.instagramHandle) {
            setNewUserInstagram(
              data?.data?.data?.user?.customer?.instagramHandle.replace(
                /^@+/,
                "",
              ),
            );
          }

          if (data?.data?.data?.user?.customer?.shippingAddress) {
            setNewUserShippingAddress(
              data?.data?.data?.user?.customer?.shippingAddress,
            );
          }

          if (data?.data?.data?.user?.customer?.billingAddress) {
            setNewUserBillingAddress(
              data?.data?.data?.user?.customer?.billingAddress,
            );
          }

          await StorageUtils.set("user_customer", data?.data?.data?.user);
        },
        (e) => {
          console.error(e);

          // TODO: error here with reload button
        },
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    loadUser();
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Member Information</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Member Information"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="text-center ion-padding pln-onboarding-container">
          <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.25rem]">
            Confirm Your Information
          </h2>
          <p className="" style={{ fontSize: 18 }}>
            Let's get started by making sure your profile is up to date,{" "}
            {StringUtils.getFirstName(user?.name)}!
          </p>
          <div className="mt-[1rem] mb-[1rem] border-t-[1px] border-gray-100"></div>
          <div>
            <h3 className="font-medium font-[SourceSerif] text-xl mb-0">
              Contact Information
            </h3>
            <p className="text-base mb-4">
              Please confirm your contact information below:
            </p>
            <div className="relative mb-4  max-w-[700px] mx-auto">
              {loading ? (
                <>
                  <IonSkeletonText
                    className="rounded h-[50px] w-full"
                    animated={true}
                  ></IonSkeletonText>
                </>
              ) : (
                <>
                  <label
                    htmlFor="name"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Name
                  </label>
                  <input
                    auto-capitalize="none"
                    type="text"
                    name="name"
                    id="name"
                    autoComplete="name"
                    className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                    placeholder="Jane Appleseed"
                    value={newUserName}
                    required={true}
                    onChange={(event: any) => {
                      setNewUserName(event?.target?.value);
                    }}
                  />
                </>
              )}
            </div>
            <div className="relative mb-4  max-w-[700px] mx-auto">
              {loading ? (
                <IonSkeletonText
                  className="rounded h-[50px] w-full"
                  animated={true}
                ></IonSkeletonText>
              ) : (
                <>
                  <label
                    htmlFor="email"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Email
                  </label>
                  <input
                    auto-capitalize="none"
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="email"
                    className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                    placeholder="jane@projectleannation.com"
                    value={newUserEmail}
                    required={true}
                    onChange={(event: any) => {
                      setNewUserEmail(event?.target?.value);
                    }}
                  />
                </>
              )}
            </div>
            <div className="relative mb-4  max-w-[700px] mx-auto">
              {loading ? (
                <IonSkeletonText
                  className="rounded h-[50px] w-full"
                  animated={true}
                ></IonSkeletonText>
              ) : (
                <>
                  <label
                    htmlFor="phone"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Phone
                  </label>
                  <input
                    auto-capitalize="none"
                    type="text"
                    name="phone"
                    id="phone"
                    autoComplete="tel"
                    className="block w-full outline-0 rounded border-[1px] px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 shadow-sm ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                    placeholder="+1 555-555-5555"
                    value={newUserPhoneReadable}
                    required={true}
                    onChange={(event: any) => {
                      const res: any = StringUtils.formatPhoneNumberWhileTyping(
                        event?.target?.value?.toString(),
                      );

                      setNewUserPhone(res?.value?.split(" ").join(""));
                      setNewUserPhoneReadable(res?.formatted);
                    }}
                  />
                </>
              )}
            </div>
            <div className="relative mb-4  max-w-[700px] mx-auto">
              {loading ? (
                <IonSkeletonText
                  className="rounded h-[50px] w-full"
                  animated={true}
                ></IonSkeletonText>
              ) : (
                <>
                  <label
                    htmlFor="instagram"
                    className="absolute -top-2 left-2 inline-block bg-white px-1 text-xs sm:text-sm font-medium text-gray-900"
                  >
                    Instagram Username (Optional)
                  </label>
                  <div className="flex w-full rounded border-[1px] shadow-sm overflow-hidden">
                    <span
                      className="inline-flex items-center px-3 text-gray-500 bg-gray-50 border-r-[1px] border-gray-200 text-sm sm:text-base select-none"
                      aria-hidden="true"
                    >
                      @
                    </span>
                    <input
                      auto-capitalize="none"
                      type="text"
                      name="instagram"
                      id="instagram"
                      autoComplete="instagram"
                      className="block w-full min-w-0 outline-0 border-0 px-[0.75rem] py-[0.75rem] sm:px-3 sm:py-3 text-gray-900 ring-0 placeholder:text-gray-400 text-sm sm:text-base sm:leading-6"
                      placeholder="your_instagram_username"
                      value={newUserInstagram ?? ""}
                      required={true}
                      onChange={(event: any) => {
                        const value =
                          event?.target?.value?.replace(/^@+/, "") ?? "";
                        setNewUserInstagram(value);
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="mt-[1rem] mb-[1rem] border-t-[1px] border-gray-100"></div>
          <div className="max-w-[700px] mx-auto">
            <BillingAddressForm
              loading={loading}
              user={user?.customer}
              autoFill="billingAddress"
              onChange={(billingAddress: any) => {
                setNewUserBillingAddress(billingAddress);
              }}
              title={"Billing Address"}
              description={"Add or confirm your billing address below"}
            ></BillingAddressForm>
          </div>

          {user?.customer?.subscription?.plan?.procurement != "pickup" &&
          !loading ? (
            <div className="max-w-[700px] mx-auto">
              <BillingAddressForm
                loading={loading}
                user={user?.customer}
                autoFill="shippingAddress"
                onChange={(shippingAddress: any) => {
                  setNewUserShippingAddress(shippingAddress);
                }}
                title={`Delivery Information`}
                description={"Let's get your orders to the right place:"}
              ></BillingAddressForm>
            </div>
          ) : null}
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar
          className={`pln-native-toolbar-footer ${
            !Capacitor.isNativePlatform() && "web"
          }`}
        >
          <IonButton
            disabled={!stepIsValid() || submitting}
            onClick={() => {
              submit();
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            {submitting ? (
              <IonSpinner className="h-[22px]" name="dots"></IonSpinner>
            ) : (
              "Continue"
            )}
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default PLNPlusMemberInformationPage;
